var _rect, _path, _path2, _path3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpertise4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 104,
    viewBox: "0 0 137 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0000686646,
    width: 136.494,
    height: 86.3532,
    rx: 10,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.113 73.8164C73.6486 73.8164 75.657 73.8164 77.2289 74.0314C78.8465 74.2527 80.1558 74.7189 81.1883 75.7694C82.2208 76.82 82.6792 78.1521 82.8966 79.798C83.1079 81.3972 83.1079 83.4407 83.1079 86.0204V91.7942C83.1079 94.374 83.1079 96.4175 82.8966 98.0166C82.6792 99.6625 82.2208 100.995 81.1883 102.045C80.1558 103.096 78.8465 103.562 77.2289 103.783C75.657 103.998 73.6486 103.998 71.1132 103.998H70.9573C68.4217 103.998 66.4133 103.998 64.8415 103.783C63.2238 103.562 61.9145 103.096 60.882 102.045C59.8494 100.995 59.3912 99.6625 59.1737 98.0166C58.9624 96.4175 58.9624 94.374 58.9624 91.7942V86.0204C58.9624 83.4406 58.9624 81.3972 59.1737 79.798C59.3912 78.1521 59.8494 76.82 60.882 75.7694C61.9145 74.7189 63.2238 74.2527 64.8415 74.0314C66.4133 73.8164 68.4217 73.8164 70.9573 73.8164H71.113Z",
    fill: "#306EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0172 98.3398C67.3922 98.3398 66.8854 98.8466 66.8854 99.4717C66.8854 100.097 67.3922 100.603 68.0172 100.603H75.5627C76.1878 100.603 76.6945 100.097 76.6945 99.4717C76.6945 98.8466 76.1878 98.3398 75.5627 98.3398H68.0172Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9262 92.6803C52.9262 90.5607 52.9262 89.5011 53.4349 88.7399C53.6551 88.4103 53.938 88.1273 54.2676 87.9072C55.0288 87.3984 56.0886 87.3984 58.208 87.3984C60.3275 87.3984 61.3872 87.3984 62.1485 87.9072C62.478 88.1273 62.761 88.4103 62.9812 88.7399C63.4898 89.5011 63.4898 90.5607 63.4898 92.6803V98.7166C63.4898 100.836 63.4898 101.896 62.9812 102.657C62.761 102.987 62.478 103.27 62.1485 103.49C61.3872 103.998 60.3275 103.998 58.208 103.998C56.0886 103.998 55.0288 103.998 54.2676 103.49C53.938 103.27 53.6551 102.987 53.4349 102.657C52.9262 101.896 52.9262 100.836 52.9262 98.7166V92.6803Z",
    fill: "#7BA1F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12.5351,
    cy: 12.5356,
    r: 2.78559,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 20.8917,
    cy: 12.5356,
    r: 2.78559,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 29.2486,
    cy: 12.5356,
    r: 2.78559,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise4);
export default __webpack_public_path__ + "static/media/expertise-4.6fde3d5496fbb17269dfca2647d0b7b7.svg";
export { ForwardRef as ReactComponent };